var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[(this.user)?[_c('trs-userform',{attrs:{"userIsMe":true},model:{value:(this.user),callback:function ($$v) {_vm.$set(this, "user", $$v)},expression:"this.user"}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }